var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.0) scale(0.521739)"
  }, /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("rect", {
    id: "teenyicons:ab-testing-outline",
    rx: 7.5,
    width: 45,
    height: 45,
    transform: "translate(0.500000 0.500000)",
    fill: "currentColor",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8 29.53L11.8 21.13C11.8 20.14 12.19 19.19 12.89 18.49C13.59 17.79 14.54 17.4 15.53 17.4C16.52 17.4 17.47 17.79 18.17 18.49C18.87 19.19 19.26 20.14 19.26 21.13L19.26 29.53M11.8 24.86L19.26 24.86M31.4 23C32.14 23 32.85 23.29 33.38 23.82C33.9 24.34 34.2 25.05 34.2 25.8C34.2 26.54 33.9 27.25 33.38 27.78C32.85 28.3 32.14 28.6 31.4 28.6L26.73 28.6L26.73 23L26.73 17.4L31.4 17.4C32.14 17.4 32.85 17.69 33.38 18.22C33.9 18.74 34.2 19.45 34.2 20.2C34.2 20.94 33.9 21.65 33.38 22.18C32.85 22.7 32.14 23 31.4 23L26.73 23M23 10.86L23 35.13",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 2.875,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestsIcon);
export default __webpack_public_path__ + "static/media/testsIcon.73019619cae94a728dc1c25b02e2e088.svg";
export { ForwardRef as ReactComponent };